export default __webpack_public_path__ + "static/media/trash.bd18ef00.svg";